/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Manage_Threads_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to rename, delete, close and turn on slow mode for threads and posts. They can also view private threads." |
*
* @param {Leveling_Perm_Manage_Threads_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_manage_threads_hint = /** @type {((inputs?: Leveling_Perm_Manage_Threads_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Manage_Threads_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам переименовывать, удалять и закрывать ветки и публикации, а также включать в них медленный режим. Кроме того, участники с этим правом видят приватные ветки.")
	return /** @type {LocalizedString} */ ("Allows members to rename, delete, close and turn on slow mode for threads and posts. They can also view private threads.")
});